import React, { PureComponent } from 'react';

export default class IconComponent extends PureComponent {

    render() {

        let className = this.props.iconClassName !== undefined ? this.props.iconClassName.toLowerCase() : null;

        return (
            <span className='portal-icon-component' title={this.props.title}>
                <span className={`${className}`} 
                    onClick={this.props.onClick}
                    onMouseOver={this.props.onMouseOver}></span>
                <span className='icon-text'>{this.props.text}</span>
            </span>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/portal/iconComponent.jsx